import qualityEventsHelpers from '../quality-events.helpers';

export const CART_PAGE_EVENTS = {
    clickCartButton: (props: { cartItemCount: number; onFinish: VoidFunction }): Promise<void> =>
        qualityEventsHelpers
            .track({ type: 'clickCartButton', extra: getExtra({ cart_item_count: props.cartItemCount }) })
            .finally(props.onFinish),

    clickCartIcon: (props: { cartItemCount: number; onFinish: VoidFunction }): Promise<void> =>
        qualityEventsHelpers
            .track({ type: 'clickCartIcon', extra: getExtra({ cart_item_count: props.cartItemCount }) })
            .finally(props.onFinish),

    clickMaterialFromCart: (props: { item: Material; itemIndex: number; onFinish: VoidFunction }): Promise<void> =>
        qualityEventsHelpers
            .track({
                type: 'clickMaterialFromCart',
                ...qualityEventsHelpers.extractMaterialsData(props.item, { itemIndex: props.itemIndex }),
                extra: getExtra()
            })
            .finally(props.onFinish),

    viewCart: (props: { cartTotalValue: string; cartItems: CartItem[] }): Promise<void> =>
        qualityEventsHelpers.track({
            type: 'viewCart',
            extra: getExtra({
                cart_total_value: props.cartTotalValue,
                cart_item_count: props.cartItems.length,
                items: props.cartItems?.map((item) => ({ id: item.id, finalPrice: item.finalPrice })) ?? []
            })
        }),

    clickBuyNowButton: ({ item }: { item: Material }): Promise<void> =>
        qualityEventsHelpers.track({
            type: 'clickBuyNowButton',
            ...qualityEventsHelpers.extractMaterialsData(item),
            extra: getExtra()
        }),
    goToPaymentMobile(goToPaymentPage: () => void) {
        qualityEventsHelpers.track({ type: 'go-to-payment-mobile-click' }).finally(goToPaymentPage);
    },

    clickPPExpressButton: (userId: number | null) =>
        qualityEventsHelpers.track({
            type: 'clickPPExpressButton',
            extra: getExtra({ user_id: userId || 'guest' })
        })
};

const getExtra = (
    extraFields: Record<
        string,
        | string
        | number
        | {
              id: number;
              finalPrice: string;
          }[]
    > = {}
): string | null => JSON.stringify({ ...getDateAndTime(), ...extraFields });

const getDateAndTime = (): Record<string, string | number> => {
    const now = new Date();

    return {
        date: now.toISOString(),
        time: now.getTime()
    };
};
